// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__VMkg6","search":"Settings_search__2YiOc","filter":"Settings_filter__992s4"};